import React, { useEffect, useState } from "react";
import heroImage1 from "../../assets/rentalCarrusel1.webp";
import heroImage2 from "../../assets/rentalCarrusel2.webp";
import heroImage3 from "../../assets/rentalCarrusel3.webp";

const CAROUSEL_SLIDES = [
	{ id: 1, src: heroImage1, alt: "Auto ejecutivo de lujo en carretera" },
	{ id: 2, src: heroImage2, alt: "Interior de vehículo confortable" },
	{ id: 3, src: heroImage3, alt: "Flota de vehículos premium" },
];

export default function Carousel() {
	const [currentIndex, setCurrentIndex] = useState(0);
	const TRANSITION_INTERVAL = 5000;

	useEffect(() => {
		const timer = setInterval(() => {
			setCurrentIndex((prevIndex) =>
				prevIndex === CAROUSEL_SLIDES.length - 1 ? 0 : prevIndex + 1
			);
		}, TRANSITION_INTERVAL);

		return () => clearInterval(timer);
	}, []);

	return (
		<div className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-slate-900">
			{CAROUSEL_SLIDES.map((slide, index) => (
				<div
					key={slide.id}
					className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ease-in-out ${
						index === currentIndex ? "opacity-100" : "opacity-0"
					}`}
				>
					<div
						className="w-full h-full bg-cover bg-center bg-fixed"
						style={{ backgroundImage: `url(${slide.src})` }}
						role="img"
						aria-label={slide.alt}
					/>
					<div className="absolute inset-0 bg-black/50" />
				</div>
			))}

			<div className="relative z-10 container mx-auto px-6 py-12 grid md:grid-cols-2 gap-12 items-center">
				<div className="text-white space-y-6 animate-fade-in-up">
					<h2 className="text-4xl md:text-6xl font-bold leading-tight">
						Autos Ejecutivos <br />
						<span className="text-[#e93640]">Premium</span>
					</h2>
					<p className="text-lg md:text-xl text-gray-200 leading-relaxed max-w-lg">
						Llegue con estilo y nunca lo olvidarán. Nuestra flota incluye
						algunos de los vehículos más deseados del mundo.
						<strong> Conduzca su sueño.</strong>
					</p>
				</div>

				<div className="bg-[#001d3b]/90 backdrop-blur-sm p-8 rounded-xl shadow-2xl border border-white/10">
					<div className="mb-6">
						<h3 className="text-2xl font-bold text-white uppercase tracking-wider">
							Cotización Rápida
						</h3>
						<p className="text-gray-300 text-sm mt-2">
							Díganos lo que busca y le responderemos en breve.
						</p>
					</div>

					<form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
						<div>
							<label htmlFor="marca" className="sr-only">
								Marca del auto
							</label>
							<input
								id="marca"
								name="marca"
								className="w-full bg-white/10 text-white placeholder-gray-400 px-4 py-3 rounded-lg border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#e93640] focus:border-transparent transition-all"
								type="text"
								placeholder="Ej. BMW, Mercedes..."
							/>
						</div>

						<div>
							<label htmlFor="destino" className="sr-only">
								Destino
							</label>
							<input
								id="destino"
								name="destino"
								className="w-full bg-white/10 text-white placeholder-gray-400 px-4 py-3 rounded-lg border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#e93640] focus:border-transparent transition-all"
								type="text"
								placeholder="Destino de viaje"
							/>
						</div>

						<div>
							<label htmlFor="fecha" className="sr-only">
								Fecha de alquiler
							</label>
							<input
								id="fecha"
								name="fecha"
								className="w-full bg-white/10 text-white placeholder-gray-400 px-4 py-3 rounded-lg border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#e93640] focus:border-transparent transition-all [color-scheme:dark]"
								type="date"
							/>
						</div>

						<button
							type="button"
							className="w-full bg-[#e93640] hover:bg-[#c42b34] text-white font-bold py-3 rounded-lg transition-colors duration-300 shadow-lg mt-2"
						>
							Consultar Disponibilidad
						</button>
					</form>
				</div>
			</div>
		</div>
	);
}
